export default function FormPreparation() {
    return (
      <div>
        <h1 className="text-2xl font-bold mb-4">Form Preparation</h1>
        <p>Form building and preparation tools will be displayed here.</p>
      </div>
    );
  }